var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 13.3332V11.7498H2.84115L2.52448 11.4728C1.83837 10.8658 1.35677 10.1731 1.07969 9.39463C0.802604 8.61616 0.664062 7.83109 0.664062 7.03942C0.664062 5.57484 1.10278 4.27189 1.98021 3.13057C2.85764 1.98925 4.00226 1.23386 5.41406 0.864421V2.52692C4.46406 2.86998 3.69878 3.45383 3.11823 4.27848C2.53767 5.10314 2.2474 6.02345 2.2474 7.03942C2.2474 7.63317 2.35955 8.21043 2.58385 8.77119C2.80816 9.33196 3.15781 9.84984 3.63281 10.3248L3.83073 10.5228V8.58317H5.41406V13.3332H0.664062ZM8.58073 13.1353V11.4728C9.53073 11.1297 10.296 10.5458 10.8766 9.72119C11.4571 8.89654 11.7474 7.97623 11.7474 6.96025C11.7474 6.3665 11.6352 5.78925 11.4109 5.22848C11.1866 4.66772 10.837 4.14984 10.362 3.67484L10.1641 3.47692V5.4165H8.58073V0.666504H13.3307V2.24984H11.1536L11.4703 2.52692C12.1168 3.17345 12.5885 3.87605 12.8854 4.63473C13.1823 5.39341 13.3307 6.16859 13.3307 6.96025C13.3307 8.42484 12.892 9.72779 12.0146 10.8691C11.1372 12.0104 9.99253 12.7658 8.58073 13.1353Z",
    fill: "#878787"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.54292be0186904589b3a1aeffede8789.svg";
export { ForwardRef as ReactComponent };